import AutoAcceptDeliverySlip from "./saga";

import { url as settingsUrl } from "app/Settings/config";
import { registerRoutings } from "rootRouting";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const url = `${settingsUrl}/modules/AutoAcceptDeliverySlip`;
export const permissionKey = "module";

interface IConfig {
    permissions: {
        update: boolean;
    };
    routing: Array<string>;
    url: string;
}

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        permissions: {
            update: false,
        },
        routing: [],
        url,
    };

    if (!settings.modules.AutoAcceptDeliverySlip) {
        return config;
    }

    const modulePermissions = permissions.filter(
        (item) => item.indexOf(permissionKey) === 0
    );

    let routing: routingType = [];

    if (modulePermissions.indexOf(permissionKey + ".update") !== -1) {
        config.permissions.update = true;
        store.injectSaga?.("AutoAcceptDeliverySlip", AutoAcceptDeliverySlip);

        routing.push({
            path: url,
            element: (
                <AsyncComponent
                    isModule={true}
                    path="AutoAcceptDeliverySlip/pages/AutoAcceptDeliverySlipIndexPage"
                />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
